export enum OrganizationServicesOffered {
    BOOKKEEPING = "bookkeeping",
    TAXES = "taxes",
    ADVISORY = "advisory",
}

export type {
    Organization,
    OrganizationProfile,
    OrganizationUserAssignment,
} from "@common/schemas/organization.schema";
